document.addEventListener("DOMContentLoaded", () => {
  // Tous les boutons quick add
  document.querySelectorAll(".btn--quick[data-add-to-cart]").forEach((btn) => {
    btn.addEventListener(
      "click",
      async (e) => {
        console.log("🟦 CLICK QUICK ADD détecté sur :", btn);

        // On override le comportement du thème
        e.preventDefault();
        e.stopImmediatePropagation();

        const form = btn.closest("form.quick__form");
        if (!form) {
          console.log("❌ Pas de form.quick__form trouvé");
          return;
        }

        // Variante principale
        const mainVariantId =
          btn.dataset.variantId ||
          form.querySelector('input[name="id"]')?.value;

        if (!mainVariantId) {
          console.error("❌ Impossible de trouver la variante principale");
          return;
        }

        // Container pour les tags (si tu les utilises toujours)
        const container =
          btn.closest(".product-grid-item__inner") ||
          btn.closest(".product-grid-item") ||
          btn.closest("hover-product-card");

        // UI loading
        const textElement =
          btn.querySelector(".hv-cta-text") || btn.querySelector(".btn__text");
        const spinner =
          btn.querySelector(".hv-loading-spinner") ||
          btn.querySelector(".btn__loader");

        const originalText = textElement?.textContent || "";

        btn.disabled = true;
        if (spinner) spinner.classList.remove("hv-hidden");
        if (textElement) textElement.textContent = "Ajout...";

        // 1) Déterminer l’app liée (si elle existe)
        let upsellVariantId = null;
        let sellingPlanId = null;

        // a) On regarde d’abord si on est dans un <hover-product-card> avec data-seal-*
        const productCard = btn.closest("hover-product-card");
        if (
          productCard &&
          productCard.dataset.sealSubscriptionProductVariantId
        ) {
          upsellVariantId =
            productCard.dataset.sealSubscriptionProductVariantId;
          sellingPlanId =
            productCard.dataset.sealSubscriptionSellingPlanId || null;

          console.log("🔗 App liée trouvée via hover-product-card :", {
            upsellVariantId,
            sellingPlanId,
          });
        } else {
          // b) Fallback : mapping via tags (3_months / 6_months / 12_months)
          const tagsStr = container?.dataset.tags || "";
          const tags = tagsStr
            .split(",")
            .map((t) => t.trim())
            .filter(Boolean);

          console.log("🏷️ Tags trouvés :", tags);

          const has3 = tags.includes("3_months");
          const has6 = tags.includes("6_months");
          const has12 = tags.includes("12_months");

          if (has3) {
            upsellVariantId = "55584832946556";
            sellingPlanId = "710814564732";
          } else if (has6) {
            upsellVariantId = "55534153499004";
            sellingPlanId = "710738542972";
          } else if (has12) {
            upsellVariantId = "55584834191740";
            sellingPlanId = "710814597500";
          }

          if (upsellVariantId) {
            console.log("🔗 App liée trouvée via tags :", {
              upsellVariantId,
              sellingPlanId,
            });
          }
        }

        try {
          // 2) On récupère le panier pour vérifier si l’app liée existe déjà
          const cartData = await fetch("/cart.js").then((res) => res.json());

          const itemsToAdd = [
            {
              id: Number(mainVariantId),
              quantity: 1,
            },
          ];

          if (upsellVariantId) {
            const alreadyLinked = cartData.items.some(
              (item) =>
                Number(item.id) === Number(upsellVariantId) &&
                item.properties &&
                item.properties.parent_variant == mainVariantId
            );

            if (alreadyLinked) {
              console.log(
                "⛔ App déjà liée pour ce parent_variant → on ne la réajoute pas"
              );
            } else {
              const appItem = {
                id: Number(upsellVariantId),
                quantity: 1,
                properties: {
                  parent_variant: mainVariantId, // clef utilisée partout pour la liaison
                },
              };

              if (sellingPlanId) {
                appItem.selling_plan = Number(sellingPlanId);
              }

              itemsToAdd.push(appItem);
            }
          }

          console.log("➕ Items à ajouter :", itemsToAdd);

          // 3) Ajout au panier en une seule requête
          const addRes = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({ items: itemsToAdd }),
          });

          if (!addRes.ok) {
            const err = await addRes.json().catch(() => ({}));
            throw new Error(err.message || "Échec de l’ajout au panier");
          }

          console.log("🛒 Mise à jour du drawer");

          if (
            typeof cart !== "undefined" &&
            typeof cart.getCart === "function"
          ) {
            await cart.getCart();
          }

          document.body.classList.add("js-drawer-open-cart");

          if (textElement) {
            textElement.textContent = "Ajouté !";
            setTimeout(() => {
              textElement.textContent = originalText;
            }, 2000);
          }
        } catch (err) {
          console.error("❌ Erreur Quick Add APP :", err);
          if (textElement) {
            textElement.textContent = "Erreur";
            setTimeout(() => {
              textElement.textContent = originalText;
            }, 2000);
          }
        }

        // Reset UI
        if (spinner) spinner.classList.add("hv-hidden");
        btn.disabled = false;
      },
      true // capture pour passer avant le handler du thème si jamais
    );
  });
});
